import Episode from './Episode';

export default Episode;
